import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProgramasDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProgramasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getProgramasService(): Observable<BodyListResponse<ProgramasDTO>> {
    return this.http.get<BodyListResponse<ProgramasDTO>>(API_URL + '/api/v1/programas/todos');
  }

   getProgramasActivosService(): Observable<BodyListResponse<ProgramasDTO>> {
    return this.http.get<BodyListResponse<ProgramasDTO>>(API_URL + '/api/v1/programas');
  }

  guardarProgramasService(programasDTO: ProgramasDTO): Observable<BodyResponse<ProgramasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/programas', programasDTO);
  }

  getProgramasPorCodigoService(codigo: string): Observable<BodyResponse<ProgramasDTO>> {
    return this.http.get<BodyResponse<ProgramasDTO>>(API_URL + '/api/v1/programas/' + codigo);
  }
}
